import * as React from 'react';

import {Button} from 'shells/button/button';
import {Card} from 'shells/card/card';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

type Props = {
    onClick: () => void;
};

export function AddDomainCard(props: Props) {
    return (
        <>
            <Card hasBorder={true}>
                <div className='pad-24'>
                    <StackLegacy
                        isHorizontal={true}
                        alignCenter={true}
                        justifyContent='space-between'
                        isFullWidth={true}
                    >
                        <StackLegacy spacing={6} isFullWidth={true}>
                            <Body isBold={true} size='large'>
                                Your domain + Nutshell
                            </Body>
                            <Body color='light'>
                                Configure DNS to power-up Nutshell features with your custom domain.
                            </Body>
                        </StackLegacy>
                        <Button variant='primary' size='big' onClick={props.onClick}>
                            Add a domain
                        </Button>
                    </StackLegacy>
                </div>
            </Card>
        </>
    );
}
